import { Icon } from '@chakra-ui/react';

const PCImageGalleryIcon = (props) => (
  <Icon
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 30 30"
    fill={'#4A5668'}
    // style="enable-background:new 0 0 1500 1500;"
    {...props}>
    <g>
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M6.35,21.76c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C7.07,22.08,6.74,21.76,6.35,21.76z M6.35,22.94c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					S6.6,22.94,6.35,22.94z"
            />
            <g>
              <path
                class="st0"
                d="M6.33,24.51c-0.19,0-0.18,0-0.23-0.19C6,23.98,5.79,23.76,5.46,23.7c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C6.9,24.66,6.65,24.52,6.33,24.51z"
              />
              <path
                class="st0"
                d="M6.36,26.39c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C6.39,26.38,6.38,26.39,6.36,26.39z M6.21,24.42c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C6.2,24.39,6.21,24.41,6.21,24.42z M4.43,24.1c0.05,0.01,0.08,0,0.11-0.04
						C4.51,24.08,4.47,24.1,4.43,24.1z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M9.72,21.59c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01H2.83
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46C1,21.89,1,21.97,1,22.05c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07c-0.02-0.08-0.02-0.16-0.02-0.24c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C9.76,21.76,9.74,21.68,9.72,21.59z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M6.35,12.69c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C7.07,13.01,6.74,12.68,6.35,12.69z M6.35,13.87c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					S6.6,13.87,6.35,13.87z"
            />
            <g>
              <path
                class="st0"
                d="M6.33,15.44c-0.19,0-0.18,0-0.23-0.19C6,14.91,5.79,14.69,5.46,14.63c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C6.9,15.59,6.65,15.45,6.33,15.44z"
              />
              <path
                class="st0"
                d="M6.36,17.31c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C6.39,17.31,6.38,17.31,6.36,17.31z M6.21,15.35c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C6.2,15.31,6.21,15.34,6.21,15.35z M4.43,15.03c0.05,0.01,0.08,0,0.11-0.04
						C4.51,15.01,4.47,15.03,4.43,15.03z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M9.72,12.52c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01H2.83
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46C1,12.82,1,12.9,1,12.98c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07C1.59,17.16,1.58,17.08,1.58,17c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C9.76,12.69,9.74,12.6,9.72,12.52z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M6.35,3.61c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C7.07,3.94,6.74,3.61,6.35,3.61z M6.35,4.8c-0.26,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					C6.81,4.59,6.6,4.8,6.35,4.8z"
            />
            <g>
              <path
                class="st0"
                d="M6.33,6.37c-0.19,0-0.18,0-0.23-0.19C6,5.84,5.79,5.62,5.46,5.56C5.13,5.49,4.84,5.61,4.65,5.91
						C4.57,6.03,4.51,6.06,4.38,6.03C4.05,5.96,3.72,6.2,3.64,6.54c0,0.02-0.01,0.03-0.01,0.05C3.62,6.64,3.61,6.72,3.53,6.7
						C3.46,6.68,3.48,6.61,3.49,6.56c0.05-0.41,0.46-0.74,0.88-0.68C4.45,5.88,4.49,5.87,4.54,5.8c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13C6.84,6.23,7.22,6.6,7.27,7.08C7.31,7.55,7.02,8,6.59,8.12
						C6.53,8.14,6.46,8.15,6.4,8.16C6.35,8.17,6.29,8.16,6.28,8.1c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C6.9,6.52,6.65,6.38,6.33,6.37z"
              />
              <path
                class="st0"
                d="M6.36,8.24c-0.14,0-0.16-0.1-0.17-0.13C6.19,8.05,6.2,8.02,6.22,7.99c0.04-0.05,0.1-0.06,0.14-0.06l0.01,0
						c0.24-0.04,0.4-0.12,0.52-0.28C7.07,7.4,7.1,7.13,6.97,6.86C6.85,6.6,6.63,6.46,6.33,6.45c-0.22,0-0.25-0.02-0.31-0.24l0-0.02
						C5.93,5.88,5.74,5.7,5.45,5.64C5.14,5.58,4.89,5.69,4.72,5.96c-0.08,0.13-0.17,0.2-0.35,0.16C4.08,6.05,3.79,6.25,3.72,6.56
						c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01C3.7,6.67,3.68,6.73,3.62,6.76C3.6,6.78,3.56,6.79,3.51,6.78
						C3.38,6.74,3.4,6.61,3.4,6.57c0-0.01,0-0.01,0-0.02c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19
						c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43C5.88,5.39,6.16,5.64,6.3,6.06c0.02,0.07,0.04,0.08,0.09,0.08
						c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13c-0.06,0.02-0.13,0.03-0.2,0.04C6.39,8.24,6.38,8.24,6.36,8.24z
						 M6.21,6.28c0.01,0,0.04,0,0.07,0c-0.04-0.02-0.07-0.04-0.1-0.07C6.2,6.24,6.21,6.27,6.21,6.28z M4.43,5.96
						c0.05,0.01,0.08,0,0.11-0.04C4.51,5.94,4.47,5.95,4.43,5.96z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M9.72,3.45C9.5,2.73,8.84,2.22,7.98,2.12c-0.01,0-0.03-0.01-0.04-0.01H2.83C2.68,2.14,2.51,2.16,2.36,2.21
				C1.59,2.47,1.14,2.96,1.02,3.67C1,3.75,1,3.83,1,3.91C1,5.25,1,6.6,1,7.95c0,0.9,0.71,1.64,1.73,1.79
				c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0C7,9.67,7.06,9.37,6.76,9.28c-1.35,0-2.35-0.04-3.7-0.04
				c-0.74,0-1.33-0.44-1.46-1.07C1.59,8.09,1.58,8.01,1.58,7.93c0-1.34,0-2.67,0-4.01c0-0.65,0.48-1.16,1.21-1.29
				C2.89,2.62,3,2.61,3.1,2.61c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98
				c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08C8.32,9.17,8.03,9.24,7.71,9.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51
				c0.02,0,0.04,0,0.06,0c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04V3.7C9.76,3.62,9.74,3.53,9.72,3.45z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M15.97,21.76c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C16.69,22.08,16.36,21.76,15.97,21.76z M15.97,22.94c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46
					c0.26,0,0.46,0.21,0.46,0.46S16.23,22.94,15.97,22.94z"
            />
            <g>
              <path
                class="st0"
                d="M15.95,24.51c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C16.52,24.66,16.27,24.52,15.95,24.51z"
              />
              <path
                class="st0"
                d="M15.99,26.39c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C16.02,26.38,16,26.39,15.99,26.39z M15.84,24.42c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C15.82,24.39,15.83,24.41,15.84,24.42z M14.06,24.1c0.05,0.01,0.08,0,0.11-0.04
						C14.13,24.08,14.1,24.1,14.06,24.1z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M19.33,21.59c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07c-0.02-0.08-0.02-0.16-0.02-0.24c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C19.37,21.76,19.35,21.68,19.33,21.59z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M15.97,12.69c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C16.69,13.01,16.36,12.68,15.97,12.69z M15.97,13.87c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46
					c0.26,0,0.46,0.21,0.46,0.46S16.23,13.87,15.97,13.87z"
            />
            <g>
              <path
                class="st0"
                d="M15.95,15.44c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						C14.2,15.1,14.14,15.13,14,15.1c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C16.52,15.59,16.27,15.45,15.95,15.44z"
              />
              <path
                class="st0"
                d="M15.99,17.31c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C16.02,17.31,16,17.31,15.99,17.31z M15.84,15.35c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C15.82,15.31,15.83,15.34,15.84,15.35z M14.06,15.03c0.05,0.01,0.08,0,0.11-0.04
						C14.13,15.01,14.1,15.03,14.06,15.03z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M19.33,12.52c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07C11.2,17.16,11.2,17.08,11.2,17c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C19.37,12.69,19.35,12.6,19.33,12.52z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M15.97,3.61c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C16.69,3.94,16.36,3.61,15.97,3.61z M15.97,4.8c-0.26,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.46,0.46-0.46
					c0.26,0,0.46,0.21,0.46,0.46C16.43,4.59,16.23,4.8,15.97,4.8z"
            />
            <g>
              <path
                class="st0"
                d="M15.95,6.37c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						C14.2,6.03,14.14,6.06,14,6.03c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C16.52,6.52,16.27,6.38,15.95,6.37z"
              />
              <path
                class="st0"
                d="M15.99,8.24c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01C13,6.74,13.02,6.61,13.03,6.57c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C16.02,8.24,16,8.24,15.99,8.24z M15.84,6.28c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C15.82,6.24,15.83,6.27,15.84,6.28z M14.06,5.96c0.05,0.01,0.08,0,0.11-0.04
						C14.13,5.94,14.1,5.95,14.06,5.96z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M19.33,3.45c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07C11.2,8.09,11.2,8.01,11.2,7.93c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04V3.7C19.37,3.62,19.35,3.53,19.33,3.45z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M25.58,21.76c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C26.3,22.08,25.97,21.76,25.58,21.76z M25.58,22.94c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					S25.84,22.94,25.58,22.94z"
            />
            <g>
              <path
                class="st0"
                d="M25.56,24.51c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C26.14,24.66,25.89,24.52,25.56,24.51z"
              />
              <path
                class="st0"
                d="M25.6,26.39c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C25.63,26.38,25.61,26.39,25.6,26.39z M25.45,24.42c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C25.43,24.39,25.44,24.41,25.45,24.42z M23.67,24.1c0.05,0.01,0.08,0,0.11-0.04
						C23.74,24.08,23.71,24.1,23.67,24.1z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M28.94,21.59c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07c-0.02-0.08-0.02-0.16-0.02-0.24c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C28.98,21.76,28.96,21.68,28.94,21.59z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M25.58,12.69c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C26.3,13.01,25.97,12.68,25.58,12.69z M25.58,13.87c-0.26,0-0.46-0.21-0.46-0.46s0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					S25.84,13.87,25.58,13.87z"
            />
            <g>
              <path
                class="st0"
                d="M25.56,15.44c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C26.14,15.59,25.89,15.45,25.56,15.44z"
              />
              <path
                class="st0"
                d="M25.6,17.31c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C25.63,17.31,25.61,17.31,25.6,17.31z M25.45,15.35c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C25.43,15.31,25.44,15.34,25.45,15.35z M23.67,15.03c0.05,0.01,0.08,0,0.11-0.04
						C23.74,15.01,23.71,15.03,23.67,15.03z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M28.94,12.52c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07c-0.02-0.08-0.02-0.16-0.02-0.24c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04v-4.45C28.98,12.69,28.96,12.6,28.94,12.52z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M25.58,3.61c-0.4,0-0.72,0.33-0.72,0.72c0,0.4,0.32,0.72,0.71,0.72c0.4,0,0.73-0.32,0.73-0.73
					C26.3,3.94,25.97,3.61,25.58,3.61z M25.58,4.8c-0.26,0-0.46-0.21-0.46-0.46c0-0.26,0.21-0.46,0.46-0.46s0.46,0.21,0.46,0.46
					C26.05,4.59,25.84,4.8,25.58,4.8z"
            />
            <g>
              <path
                class="st0"
                d="M25.56,6.37c-0.19,0-0.18,0-0.23-0.19c-0.09-0.34-0.31-0.55-0.63-0.62c-0.34-0.07-0.62,0.05-0.82,0.35
						c-0.07,0.11-0.13,0.15-0.27,0.12c-0.33-0.07-0.66,0.16-0.74,0.51c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.06-0.02,0.13-0.1,0.11
						c-0.07-0.02-0.05-0.09-0.04-0.14c0.05-0.41,0.46-0.74,0.88-0.68c0.08,0.01,0.12-0.01,0.17-0.07c0.23-0.32,0.55-0.46,0.93-0.4
						c0.38,0.06,0.63,0.31,0.75,0.68c0.03,0.09,0.07,0.13,0.16,0.13c0.46,0.01,0.83,0.38,0.88,0.86c0.05,0.47-0.25,0.92-0.68,1.04
						c-0.06,0.02-0.12,0.03-0.19,0.04c-0.05,0.01-0.11,0.01-0.12-0.06c-0.01-0.08,0.05-0.08,0.1-0.09c0.23-0.03,0.43-0.12,0.57-0.31
						c0.2-0.27,0.23-0.56,0.09-0.87C26.14,6.52,25.89,6.38,25.56,6.37z"
              />
              <path
                class="st0"
                d="M25.6,8.24c-0.14,0-0.16-0.1-0.17-0.13c-0.01-0.06,0.01-0.09,0.02-0.11c0.04-0.05,0.1-0.06,0.14-0.06
						l0.01,0c0.24-0.04,0.4-0.12,0.52-0.28c0.18-0.25,0.21-0.51,0.08-0.78c-0.12-0.27-0.34-0.41-0.64-0.42
						c-0.22,0-0.25-0.02-0.31-0.24l0-0.02c-0.08-0.31-0.27-0.5-0.57-0.56c-0.31-0.06-0.56,0.05-0.73,0.32
						c-0.08,0.13-0.17,0.2-0.35,0.16c-0.28-0.06-0.57,0.14-0.64,0.44c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02-0.01,0.03l0,0.01
						c-0.01,0.05-0.03,0.11-0.08,0.14c-0.02,0.01-0.06,0.03-0.12,0.01c-0.13-0.03-0.11-0.17-0.11-0.21c0-0.01,0-0.01,0-0.02
						c0.02-0.22,0.14-0.42,0.33-0.57c0.19-0.15,0.43-0.22,0.65-0.19c0.05,0.01,0.06,0,0.09-0.04c0.26-0.35,0.6-0.5,1.01-0.43
						c0.39,0.07,0.68,0.32,0.81,0.74c0.02,0.07,0.04,0.08,0.09,0.08c0.5,0.01,0.91,0.41,0.96,0.94c0.05,0.51-0.27,1-0.74,1.13
						c-0.06,0.02-0.13,0.03-0.2,0.04C25.63,8.24,25.61,8.24,25.6,8.24z M25.45,6.28c0.01,0,0.04,0,0.07,0
						c-0.04-0.02-0.07-0.04-0.1-0.07C25.43,6.24,25.44,6.27,25.45,6.28z M23.67,5.96c0.05,0.01,0.08,0,0.11-0.04
						C23.74,5.94,23.71,5.95,23.67,5.96z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M28.94,3.45c-0.21-0.72-0.88-1.23-1.73-1.33c-0.01,0-0.03-0.01-0.04-0.01h-5.11
				c-0.16,0.03-0.32,0.06-0.48,0.11c-0.77,0.26-1.22,0.75-1.34,1.46c-0.01,0.08-0.02,0.16-0.02,0.24c0,1.35,0,2.69,0,4.04
				c0,0.9,0.71,1.64,1.73,1.79c0.09,0.01,0.19,0.02,0.28,0.02c1.37,0,2.4,0,3.77,0c0.21-0.08,0.28-0.39-0.02-0.47
				c-1.35,0-2.35-0.04-3.7-0.04c-0.74,0-1.33-0.44-1.46-1.07c-0.02-0.08-0.02-0.16-0.02-0.24c0-1.34,0-2.67,0-4.01
				c0-0.65,0.48-1.16,1.21-1.29c0.1-0.02,0.2-0.02,0.31-0.02c1.53,0,3.07,0,4.6,0c0.75,0,1.35,0.44,1.47,1.09
				c0.02,0.08,0.02,0.16,0.02,0.25c0,0.66,0,1.32,0,1.98c0,0.67,0,1.33,0,2c0,0.45-0.2,0.81-0.62,1.08
				c-0.25,0.16-0.54,0.24-0.86,0.24c-0.01,0-0.01,0-0.02,0c-0.23,0.15-0.25,0.42,0,0.51c0.02,0,0.04,0,0.06,0
				c1.01,0,1.88-0.68,2-1.56c0-0.01,0.01-0.03,0.02-0.04V3.7C28.98,3.62,28.96,3.53,28.94,3.45z"
          />
        </g>
      </g>
    </g>
  </Icon>
);
export default PCImageGalleryIcon;
